// extracted by mini-css-extract-plugin
export var autoExpand = "_24-8";
export var container = "_24-7";
export var containerWidth = "_24-5";
export var disabled = "_24-2";
export var error = "_24-3";
export var fullWidth = "_24-6";
export var inputWrapper = "_24-0";
export var small = "_24-1";
export var textarea = "_24-4";